import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { MedicalFeePaymentService } from 'src/app/services/medical-fee/medical-fee-payment.service';
import { FilterService } from 'src/app/services/filter.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { SearchFilter, IFilterComponent } from 'src/app/infrastructure/iFilter-component';
import { MedicalFeePeriodFilter } from '../../../model/medical-fee/medical-fee-period-filter';

@Component({
  selector: 'app-medical-fee-payment-filter',
  templateUrl: './medical-fee-payment-filter.component.html',
  styleUrls: ['./medical-fee-payment-filter.component.css']
})
export class MedicalFeePaymentFilterComponent implements IFilterComponent,  OnInit {

  form: FormGroup;
  filterCompletePhysician: FilterCompleteService<PhysicianFilter>;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  medicalFeePeriodFilters: MedicalFeePeriodFilter[];

  constructor(  private formBuilder: FormBuilder,
                private mfpService: MedicalFeePaymentService,
                private filterService: FilterService,
                private notificationToastService: NotificationToastService,
                private filterRecordService: FilterRecordService) {


    this.form = this.formBuilder.group({
      number: [''],
      physician: [''],
      from: [''],
      to: [''],
      paymentDate: [''],
      medicalFeePeriod: [''],
    }, { validators: this.formEmpty('number', 'physician',
                         'from', 'to', 'paymentDate',
                         'medicalFeePeriod') });

    this.filterCompletePhysician =
      new FilterCompleteService<PhysicianFilter>([], this.form.controls.physician);
  }

  get f() { return this.form.controls; }

  get filteredPhysicianOptions() { return this.filterCompletePhysician ?
    this.filterCompletePhysician.filteredOptions : []; }

  ngOnInit(): void {

    this.filterService.getMedicalFeeBillPeriodFilters().then( (items) => {
      this.medicalFeePeriodFilters = items;
    });

    this.loadPhysicians();
  }

  private loadPhysicians() {
    this.filterService.getPhysiciansFilter().then( ( items ) => {
      this.filterCompletePhysician =
        new FilterCompleteService<PhysicianFilter>(items, this.form.controls.physician);
    });
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('MedicalFeePaymentFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('MedicalFeePaymentFilterComponent', this.form);
  }

  async search(): Promise<any> {

      try {

         if ( this.form.valid ) {
          return await this.mfpService.getMedicalFeePaymentSearchItems(
            this.form.controls.number.value,
            this.form.controls.physician.value ? this.form.controls.physician.value.Id : null,
            this.form.controls.from.value ? this.form.controls.from.value : null,
            this.form.controls.to.value ? this.form.controls.to.value : null,
            this.form.controls.paymentDate.value ? this.form.controls.paymentDate.value : null,
            this.form.controls.medicalFeePeriod.value ? this.form.controls.medicalFeePeriod.value.Id : null
            );

        } else {

          this.notificationToastService.error('Debe ingresar al menos un filtro', 'Honorarios');
          Object.values( this.form.controls ).forEach( control => {
            control.markAsTouched();
          });

          return [];
        }
      } catch ( err ) {
        console.log(  err );
        this.notificationToastService.error(JSON.stringify( err.error ), 'Honorarios');
      }
  }

  formEmpty( number: string, physician: string, from: string,
             to: string, paymentDate: string,  medicalFeePeriod: string ) {

    return ( formGroup: FormGroup ) => {

      const numberControl = formGroup.controls[number];
      const physicianControl = formGroup.controls[physician];
      const paymentDateControl = formGroup.controls[paymentDate];
      const fromControl = formGroup.controls[from];
      const toControl = formGroup.controls[to];
      const medicalFeePeriodControl = formGroup.controls[medicalFeePeriod];

      if ( !numberControl.value &&
           !fromControl.value &&
           !paymentDateControl.value &&
           !toControl.value &&
           !medicalFeePeriodControl.value &&
         ( !physicianControl.value || typeof physicianControl.value === 'string' ) ) {
        numberControl.setErrors({ formEmpty: true });
        physicianControl.setErrors({ formEmpty: true });
        fromControl.setErrors({ formEmpty: true });
        toControl.setErrors({ formEmpty: true });
        paymentDateControl.setErrors({ formEmpty: true });
        medicalFeePeriodControl.setErrors({ formEmpty: true });
      } else {
        numberControl.setErrors( null );
        physicianControl.setErrors( null );
        fromControl.setErrors( null );
        toControl.setErrors( null );
        paymentDateControl.setErrors( null );
        medicalFeePeriodControl.setErrors( null );
      }
    };
  }
}
